import { Outlet } from "react-router-dom";
import WorkerSidebar from "./worker_sidebar";
import WorkerHeader from "../../worker-header/components/index";
import WorkerFooter from "../../worker-footer/components/index"

const WorkerDashboard = () => {
  return (
    <>
    <WorkerHeader />
    <main className="overflow-hidden">
      <section className="homepad">
        <div className="container">
          <div className="row">
            <WorkerSidebar />
            <Outlet />
          </div>
        </div>
      </section>
      <WorkerFooter />
    </main>
    </>
  );
};

export default WorkerDashboard;